import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setGlobalData } from "@redux/slices/globalSlice";
import { ThemeTokenTypes } from "@scenes/splash-screen/types";
import {
  setGlobalCustomisationLoad,
  setOrgGlobalCustomisation,
  setOverlayState,
} from "@redux/slices/appStateSlice";
import { useTheme } from "styled-components/native";

export const useGetGlobalData = (
  url: string,
  enabled?: boolean,
  type?: string
) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const overlayActiveScreens = useSelector(
    (state: any) => state.appState.overlayActiveScreens
  );
  const timestamp = Date.now();
  return useQuery({
    queryKey: ["GET_GLOBAL_DATA"],
    enabled: enabled,
    queryFn: () =>
      axios.get(url + "?timestamp=" + timestamp).then((data) => {
        if (type === ThemeTokenTypes.ORG) {
          dispatch(setOrgGlobalCustomisation(data.data));
        }
        if (type === ThemeTokenTypes.COMPANY)
          dispatch(setGlobalCustomisationLoad(true));
        if (data?.data) {
          dispatch(setGlobalData(data.data));
          if (data.data?.overlay_config?.screens && !theme.isLargeScreen) {
            Object.entries(data.data?.overlay_config?.screens).forEach(
              ([screen, config]: [string, any]) => {
                if (overlayActiveScreens[screen] === undefined) {
                  dispatch(
                    setOverlayState({
                      screen,
                      isActive: config?.overlayActive as boolean,
                    })
                  );
                }
              }
            );
          }
        }
        return data;
      }),
    onError: (err) => {
      console.log("err", err);
    },
  });
};
